const menuOpenClass = "-menuopen";
const hamburgerIcon = document.querySelector(".hamburger-icon");

if (hamburgerIcon) {
    hamburgerIcon.addEventListener("click", () => {
        let body = document.body;
        let classList = body.classList;
        let style = body.style;

        if (classList.contains(menuOpenClass)) {
            classList.remove(menuOpenClass);
            window.scrollTo(0, parseInt(style.top) * -1);
            style.top = "";
        } else {
            style.top = `-${window.scrollY}px`;
            classList.add(menuOpenClass);
        }
    });
}
